var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBees(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254.875,
    height: 124.251,
    viewBox: "0 0 254.875 124.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-1137.353 -388.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(139 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M46.337,261.6v13.075L39.329,271.6l-.453-.2-1.466-.643a12.583,12.583,0,0,1,.06-5.28l1.406-.616.343-.15Z",
    transform: "translate(1163.321 261.4)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(1132.389 309.964)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(1196.353 496.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(29.287 44.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M265.409,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M306.223,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-299.93 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M235.627,35.252l-2.878,5.393-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,34.259a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,6.543,6.543,0,0,1,3.073-.582c.069,0,.14.007.209.013l.13.012.129.009c.07.006.14.012.21.02A6.73,6.73,0,0,1,235.627,35.252Z",
    transform: "translate(-198.073 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M232.749,45.37l-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,38.984a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,8.229,8.229,0,0,1,4.421,5.929Z",
    transform: "translate(-198.073 -30.04)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M165.577,68.128l-2.034-11.372a6.421,6.421,0,0,0-9.671-4.376q-.085.053-.168.109l-.1.07-.1.068c-.056.037-.111.075-.165.113a6.421,6.421,0,0,0,.307,10.611l9.708,6.263A1.461,1.461,0,0,0,165.577,68.128Z",
    transform: "translate(-133.938 -48.521)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M408.2,113.365a2.11,2.11,0,0,0-3.426,1.847.882.882,0,0,0-.093.03c-3.617,1.4-6.091,5.974-7.168,8.714a.879.879,0,1,0,1.637.643c.948-2.412,3.144-6.55,6.165-7.717a.877.877,0,0,0,.3-.189,2.109,2.109,0,0,0,2.59-3.329Z",
    transform: "translate(-353.304 -103.167)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M13.3,261.6v13.075L6.3,271.6l-.453-.2-1.466-.643L.648,269.126a1.083,1.083,0,0,1,0-1.984l3.791-1.661,1.406-.616.343-.15Z",
    transform: "translate(0 -235.349)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(7.993 20.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M147.109,219.571a12.5,12.5,0,0,1-1.666,6.243,12.524,12.524,0,0,1-7.657,2.611h-23.67A12.643,12.643,0,0,1,101.51,215.82a12.494,12.494,0,0,1,1.667-6.245,12.523,12.523,0,0,1,7.656-2.61H134.5A12.644,12.644,0,0,1,147.109,219.571Z",
    transform: "translate(-90.234 -186.786)",
    fill: "#ffdf9c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 1.633,
    cy: 1.633,
    rx: 1.633,
    ry: 1.633,
    transform: "translate(1243.286 523.933)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(1218.946 516.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 5.532,
    height: 25.213,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 5.53,
    height: 25.213,
    transform: "translate(14.152)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(1218.946 538.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M208.915,399.626v3.748h-5.532v-3.819a11.746,11.746,0,0,0,1.29.07Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 5.53,
    height: 3.752,
    transform: "translate(14.152 0.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M224.6,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-220.684 -426.501)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M347.038,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-329.517 -426.501)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(101 -101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365-2",
    "data-name": "Path 365",
    d: "M46.337,261.6v13.075L39.329,271.6l-.453-.2-1.466-.643a12.583,12.583,0,0,1,.06-5.28l1.406-.616.343-.15Z",
    transform: "translate(1163.321 261.4)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-2",
    "data-name": "SVGCleanerId_0",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(1132.389 309.964)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39-2",
    "data-name": "Group 39",
    transform: "translate(1196.353 496.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-2",
    "data-name": "Group 21",
    transform: "translate(29.287 44.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-2",
    "data-name": "Path 358",
    d: "M265.409,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-2",
    "data-name": "Path 359",
    d: "M306.223,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-299.93 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360-2",
    "data-name": "Path 360",
    d: "M235.627,35.252l-2.878,5.393-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,34.259a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,6.543,6.543,0,0,1,3.073-.582c.069,0,.14.007.209.013l.13.012.129.009c.07.006.14.012.21.02A6.73,6.73,0,0,1,235.627,35.252Z",
    transform: "translate(-198.073 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361-2",
    "data-name": "Path 361",
    d: "M232.749,45.37l-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,38.984a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,8.229,8.229,0,0,1,4.421,5.929Z",
    transform: "translate(-198.073 -30.04)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362-2",
    "data-name": "Path 362",
    d: "M165.577,68.128l-2.034-11.372a6.421,6.421,0,0,0-9.671-4.376q-.085.053-.168.109l-.1.07-.1.068c-.056.037-.111.075-.165.113a6.421,6.421,0,0,0,.307,10.611l9.708,6.263A1.461,1.461,0,0,0,165.577,68.128Z",
    transform: "translate(-133.938 -48.521)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363-2",
    "data-name": "Path 363",
    d: "M408.2,113.365a2.11,2.11,0,0,0-3.426,1.847.882.882,0,0,0-.093.03c-3.617,1.4-6.091,5.974-7.168,8.714a.879.879,0,1,0,1.637.643c.948-2.412,3.144-6.55,6.165-7.717a.877.877,0,0,0,.3-.189,2.109,2.109,0,0,0,2.59-3.329Z",
    transform: "translate(-353.304 -103.167)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364-2",
    "data-name": "Path 364",
    d: "M13.3,261.6v13.075L6.3,271.6l-.453-.2-1.466-.643L.648,269.126a1.083,1.083,0,0,1,0-1.984l3.791-1.661,1.406-.616.343-.15Z",
    transform: "translate(0 -235.349)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22-2",
    "data-name": "Group 22",
    transform: "translate(7.993 20.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_2",
    "data-name": "SVGCleanerId_0_1_",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_366-2",
    "data-name": "Path 366",
    d: "M147.109,219.571a12.5,12.5,0,0,1-1.666,6.243,12.524,12.524,0,0,1-7.657,2.611h-23.67A12.643,12.643,0,0,1,101.51,215.82a12.494,12.494,0,0,1,1.667-6.245,12.523,12.523,0,0,1,7.656-2.61H134.5A12.644,12.644,0,0,1,147.109,219.571Z",
    transform: "translate(-90.234 -186.786)",
    fill: "#ffdf9c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53-2",
    "data-name": "Ellipse 53",
    cx: 1.633,
    cy: 1.633,
    rx: 1.633,
    ry: 1.633,
    transform: "translate(1243.286 523.933)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23-2",
    "data-name": "Group 23",
    transform: "translate(1218.946 516.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 5.532,
    height: 25.213,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 5.53,
    height: 25.213,
    transform: "translate(14.152)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24-2",
    "data-name": "Group 24",
    transform: "translate(1218.946 538.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-2",
    "data-name": "Path 367",
    d: "M208.915,399.626v3.748h-5.532v-3.819a11.746,11.746,0,0,0,1.29.07Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 5.53,
    height: 3.752,
    transform: "translate(14.152 0.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-2",
    "data-name": "Path 368",
    d: "M224.6,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-220.684 -426.501)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-2",
    "data-name": "Path 369",
    d: "M347.038,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-329.517 -426.501)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(35 -61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365-3",
    "data-name": "Path 365",
    d: "M46.337,261.6v13.075L39.329,271.6l-.453-.2-1.466-.643a12.583,12.583,0,0,1,.06-5.28l1.406-.616.343-.15Z",
    transform: "translate(1163.321 261.4)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-3",
    "data-name": "SVGCleanerId_0",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(1132.389 309.964)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39-3",
    "data-name": "Group 39",
    transform: "translate(1196.353 496.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-3",
    "data-name": "Group 21",
    transform: "translate(29.287 44.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-3",
    "data-name": "Path 358",
    d: "M265.409,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-3",
    "data-name": "Path 359",
    d: "M306.223,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-299.93 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360-3",
    "data-name": "Path 360",
    d: "M235.627,35.252l-2.878,5.393-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,34.259a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,6.543,6.543,0,0,1,3.073-.582c.069,0,.14.007.209.013l.13.012.129.009c.07.006.14.012.21.02A6.73,6.73,0,0,1,235.627,35.252Z",
    transform: "translate(-198.073 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361-3",
    "data-name": "Path 361",
    d: "M232.749,45.37l-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,38.984a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,8.229,8.229,0,0,1,4.421,5.929Z",
    transform: "translate(-198.073 -30.04)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362-3",
    "data-name": "Path 362",
    d: "M165.577,68.128l-2.034-11.372a6.421,6.421,0,0,0-9.671-4.376q-.085.053-.168.109l-.1.07-.1.068c-.056.037-.111.075-.165.113a6.421,6.421,0,0,0,.307,10.611l9.708,6.263A1.461,1.461,0,0,0,165.577,68.128Z",
    transform: "translate(-133.938 -48.521)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363-3",
    "data-name": "Path 363",
    d: "M408.2,113.365a2.11,2.11,0,0,0-3.426,1.847.882.882,0,0,0-.093.03c-3.617,1.4-6.091,5.974-7.168,8.714a.879.879,0,1,0,1.637.643c.948-2.412,3.144-6.55,6.165-7.717a.877.877,0,0,0,.3-.189,2.109,2.109,0,0,0,2.59-3.329Z",
    transform: "translate(-353.304 -103.167)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364-3",
    "data-name": "Path 364",
    d: "M13.3,261.6v13.075L6.3,271.6l-.453-.2-1.466-.643L.648,269.126a1.083,1.083,0,0,1,0-1.984l3.791-1.661,1.406-.616.343-.15Z",
    transform: "translate(0 -235.349)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22-3",
    "data-name": "Group 22",
    transform: "translate(7.993 20.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_3",
    "data-name": "SVGCleanerId_0_1_",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_366-3",
    "data-name": "Path 366",
    d: "M147.109,219.571a12.5,12.5,0,0,1-1.666,6.243,12.524,12.524,0,0,1-7.657,2.611h-23.67A12.643,12.643,0,0,1,101.51,215.82a12.494,12.494,0,0,1,1.667-6.245,12.523,12.523,0,0,1,7.656-2.61H134.5A12.644,12.644,0,0,1,147.109,219.571Z",
    transform: "translate(-90.234 -186.786)",
    fill: "#ffdf9c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53-3",
    "data-name": "Ellipse 53",
    cx: 1.633,
    cy: 1.633,
    rx: 1.633,
    ry: 1.633,
    transform: "translate(1243.286 523.933)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23-3",
    "data-name": "Group 23",
    transform: "translate(1218.946 516.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 5.532,
    height: 25.213,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 5.53,
    height: 25.213,
    transform: "translate(14.152)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24-3",
    "data-name": "Group 24",
    transform: "translate(1218.946 538.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-3",
    "data-name": "Path 367",
    d: "M208.915,399.626v3.748h-5.532v-3.819a11.746,11.746,0,0,0,1.29.07Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 5.53,
    height: 3.752,
    transform: "translate(14.152 0.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-3",
    "data-name": "Path 368",
    d: "M224.6,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-220.684 -426.501)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-3",
    "data-name": "Path 369",
    d: "M347.038,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-329.517 -426.501)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(-22 -108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365-4",
    "data-name": "Path 365",
    d: "M46.337,261.6v13.075L39.329,271.6l-.453-.2-1.466-.643a12.583,12.583,0,0,1,.06-5.28l1.406-.616.343-.15Z",
    transform: "translate(1163.321 261.4)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-4",
    "data-name": "SVGCleanerId_0",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(1132.389 309.964)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39-4",
    "data-name": "Group 39",
    transform: "translate(1196.353 496.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-4",
    "data-name": "Group 21",
    transform: "translate(29.287 44.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-4",
    "data-name": "Path 358",
    d: "M265.409,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-4",
    "data-name": "Path 359",
    d: "M306.223,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-299.93 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360-4",
    "data-name": "Path 360",
    d: "M235.627,35.252l-2.878,5.393-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,34.259a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,6.543,6.543,0,0,1,3.073-.582c.069,0,.14.007.209.013l.13.012.129.009c.07.006.14.012.21.02A6.73,6.73,0,0,1,235.627,35.252Z",
    transform: "translate(-198.073 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361-4",
    "data-name": "Path 361",
    d: "M232.749,45.37l-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,38.984a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,8.229,8.229,0,0,1,4.421,5.929Z",
    transform: "translate(-198.073 -30.04)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362-4",
    "data-name": "Path 362",
    d: "M165.577,68.128l-2.034-11.372a6.421,6.421,0,0,0-9.671-4.376q-.085.053-.168.109l-.1.07-.1.068c-.056.037-.111.075-.165.113a6.421,6.421,0,0,0,.307,10.611l9.708,6.263A1.461,1.461,0,0,0,165.577,68.128Z",
    transform: "translate(-133.938 -48.521)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363-4",
    "data-name": "Path 363",
    d: "M408.2,113.365a2.11,2.11,0,0,0-3.426,1.847.882.882,0,0,0-.093.03c-3.617,1.4-6.091,5.974-7.168,8.714a.879.879,0,1,0,1.637.643c.948-2.412,3.144-6.55,6.165-7.717a.877.877,0,0,0,.3-.189,2.109,2.109,0,0,0,2.59-3.329Z",
    transform: "translate(-353.304 -103.167)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364-4",
    "data-name": "Path 364",
    d: "M13.3,261.6v13.075L6.3,271.6l-.453-.2-1.466-.643L.648,269.126a1.083,1.083,0,0,1,0-1.984l3.791-1.661,1.406-.616.343-.15Z",
    transform: "translate(0 -235.349)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22-4",
    "data-name": "Group 22",
    transform: "translate(7.993 20.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_4",
    "data-name": "SVGCleanerId_0_1_",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_366-4",
    "data-name": "Path 366",
    d: "M147.109,219.571a12.5,12.5,0,0,1-1.666,6.243,12.524,12.524,0,0,1-7.657,2.611h-23.67A12.643,12.643,0,0,1,101.51,215.82a12.494,12.494,0,0,1,1.667-6.245,12.523,12.523,0,0,1,7.656-2.61H134.5A12.644,12.644,0,0,1,147.109,219.571Z",
    transform: "translate(-90.234 -186.786)",
    fill: "#ffdf9c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53-4",
    "data-name": "Ellipse 53",
    cx: 1.633,
    cy: 1.633,
    rx: 1.633,
    ry: 1.633,
    transform: "translate(1243.286 523.933)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23-4",
    "data-name": "Group 23",
    transform: "translate(1218.946 516.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 5.532,
    height: 25.213,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 5.53,
    height: 25.213,
    transform: "translate(14.152)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24-4",
    "data-name": "Group 24",
    transform: "translate(1218.946 538.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-4",
    "data-name": "Path 367",
    d: "M208.915,399.626v3.748h-5.532v-3.819a11.746,11.746,0,0,0,1.29.07Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 5.53,
    height: 3.752,
    transform: "translate(14.152 0.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-4",
    "data-name": "Path 368",
    d: "M224.6,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-220.684 -426.501)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-4",
    "data-name": "Path 369",
    d: "M347.038,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-329.517 -426.501)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(-59 -50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365-5",
    "data-name": "Path 365",
    d: "M46.337,261.6v13.075L39.329,271.6l-.453-.2-1.466-.643a12.583,12.583,0,0,1,.06-5.28l1.406-.616.343-.15Z",
    transform: "translate(1163.321 261.4)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-5",
    "data-name": "SVGCleanerId_0",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(1132.389 309.964)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39-5",
    "data-name": "Group 39",
    transform: "translate(1196.353 496.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-5",
    "data-name": "Group 21",
    transform: "translate(29.287 44.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-5",
    "data-name": "Path 358",
    d: "M265.409,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-5",
    "data-name": "Path 359",
    d: "M306.223,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-299.93 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360-5",
    "data-name": "Path 360",
    d: "M235.627,35.252l-2.878,5.393-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,34.259a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,6.543,6.543,0,0,1,3.073-.582c.069,0,.14.007.209.013l.13.012.129.009c.07.006.14.012.21.02A6.73,6.73,0,0,1,235.627,35.252Z",
    transform: "translate(-198.073 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361-5",
    "data-name": "Path 361",
    d: "M232.749,45.37l-1.038,1.944-1.757,3.3-.027.049a1.521,1.521,0,0,1-1.867.721,1.494,1.494,0,0,1-.932-.945L223.2,38.984a6.776,6.776,0,0,1,1.593-6.976,6.626,6.626,0,0,1,1.962-1.378,8.229,8.229,0,0,1,4.421,5.929Z",
    transform: "translate(-198.073 -30.04)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362-5",
    "data-name": "Path 362",
    d: "M165.577,68.128l-2.034-11.372a6.421,6.421,0,0,0-9.671-4.376q-.085.053-.168.109l-.1.07-.1.068c-.056.037-.111.075-.165.113a6.421,6.421,0,0,0,.307,10.611l9.708,6.263A1.461,1.461,0,0,0,165.577,68.128Z",
    transform: "translate(-133.938 -48.521)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363-5",
    "data-name": "Path 363",
    d: "M408.2,113.365a2.11,2.11,0,0,0-3.426,1.847.882.882,0,0,0-.093.03c-3.617,1.4-6.091,5.974-7.168,8.714a.879.879,0,1,0,1.637.643c.948-2.412,3.144-6.55,6.165-7.717a.877.877,0,0,0,.3-.189,2.109,2.109,0,0,0,2.59-3.329Z",
    transform: "translate(-353.304 -103.167)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364-5",
    "data-name": "Path 364",
    d: "M13.3,261.6v13.075L6.3,271.6l-.453-.2-1.466-.643L.648,269.126a1.083,1.083,0,0,1,0-1.984l3.791-1.661,1.406-.616.343-.15Z",
    transform: "translate(0 -235.349)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22-5",
    "data-name": "Group 22",
    transform: "translate(7.993 20.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_5",
    "data-name": "SVGCleanerId_0_1_",
    d: "M120.839,219.57a12.5,12.5,0,0,1-1.666,6.243,12.7,12.7,0,0,1-2.038,2.66,12.572,12.572,0,0,1-8.9,3.7H84.563a12.592,12.592,0,0,1-8.9-21.51,12.656,12.656,0,0,1,8.9-3.7h23.67A12.644,12.644,0,0,1,120.839,219.57Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_366-5",
    "data-name": "Path 366",
    d: "M147.109,219.571a12.5,12.5,0,0,1-1.666,6.243,12.524,12.524,0,0,1-7.657,2.611h-23.67A12.643,12.643,0,0,1,101.51,215.82a12.494,12.494,0,0,1,1.667-6.245,12.523,12.523,0,0,1,7.656-2.61H134.5A12.644,12.644,0,0,1,147.109,219.571Z",
    transform: "translate(-90.234 -186.786)",
    fill: "#ffdf9c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53-5",
    "data-name": "Ellipse 53",
    cx: 1.633,
    cy: 1.633,
    rx: 1.633,
    ry: 1.633,
    transform: "translate(1243.286 523.933)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23-5",
    "data-name": "Group 23",
    transform: "translate(1218.946 516.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-5",
    "data-name": "Rectangle 16",
    width: 5.532,
    height: 25.213,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-5",
    "data-name": "Rectangle 17",
    width: 5.53,
    height: 25.213,
    transform: "translate(14.152)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24-5",
    "data-name": "Group 24",
    transform: "translate(1218.946 538.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-5",
    "data-name": "Path 367",
    d: "M208.915,399.626v3.748h-5.532v-3.819a11.746,11.746,0,0,0,1.29.07Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-5",
    "data-name": "Rectangle 18",
    width: 5.53,
    height: 3.752,
    transform: "translate(14.152 0.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-5",
    "data-name": "Path 368",
    d: "M224.6,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-220.684 -426.501)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-5",
    "data-name": "Path 369",
    d: "M347.038,429.868V435.3a.879.879,0,0,1-1.759,0v-5.432Z",
    transform: "translate(-329.517 -426.501)",
    fill: "#3f3d56"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBees);
export default __webpack_public_path__ + "static/media/bees.0deab7d764dc80c34ae66975156f9daa.svg";
export { ForwardRef as ReactComponent };